import {
  AssetSortOption,
  AssetStatus,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $selectedStatus =
  atomFromQueryString.string<AssetStatus>('status');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

// 🔘🔘🔘 PLAIN ATOMS
export const $currentSorting = atom<AssetSortOption | undefined>(undefined);
